import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  constructor() {}

  /**
   *
   */
  getTenantId(): string {
    const tenantId = localStorage.getItem('tenantId');

    if (!tenantId || tenantId.trim() === '') {
      window.location.reload();
      return '';
    }
    return tenantId;
  }
}
